export default __webpack_public_path__ + "check-mark74596c.png";